import ErrorFilled from "@mui/icons-material/Error";

type OverThresholdDotProps = {
  title?: string;
  fontSize?: number;
};

export function OverThresholdDot({ title, fontSize = 24 }: OverThresholdDotProps) {
  return (
    <ErrorFilled sx={{ color: "warning.light", fontSize }} titleAccess={title} fontSize="small" />
  );
}
